module.exports = __webpack_public_path__ + "static/media/cogs.034d9e98.svg";